// extracted by mini-css-extract-plugin
export default {"title":"Shorts_title__r-c-6","shortsContainer":"Shorts_shortsContainer__3NTha","shortItem":"Shorts_shortItem__7wc4z","iframe":"Shorts_iframe__QntEL"};